import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { getProductsList } from "../../store/MRP/Products/ProductsSlice";

const useGetProductsList = () => {
  const dispatch = useAppDispatch();

  const { i18n, t } = useTranslation();

  useEffect(() => {
    if (ProductsList?.length === 0) {
      dispatch(getProductsList());
    }
  }, []);

  const { ProductsList, loading, error } = useAppSelector(
    (state) => state.MrpProducts
  );

  const optionsProducts = ProductsList?.map((m) => ({
    value: m.id,
    label: i18n.language === "en" ? m.name : m.name2,
  }));

  return { ProductsList, optionsProducts, loading, error };
};

export default useGetProductsList;
